import React from 'react';
import {
  Box,
  Typography,
  Container,
  Paper,
  Grid
} from '@mui/material';
import LayoutLandingHeader from '../components/LayoutLandingHeader';
import LayoutLandingFooter from '../components/LayoutLandingFooter';
import GSTLoader from '../components/GSTLoader';

const ContactUS = () => {
  return (
    <GSTLoader>
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <LayoutLandingHeader />

        <Box
          sx={{
            flex: 1,
            py: 6,
            px: 2,
            backgroundColor: '#f9fafc',
          }}
        >
          <Container maxWidth="md">
            <Typography
              variant="h4"
              align="center"
              gutterBottom
              sx={{
                fontWeight: 'bold',
                color: '#003366',
                mb: 4,
              }}
            >
              Contact Us
            </Typography>

            <Grid container spacing={4}>
              <Grid item xs={12} md={6}>
                <Box sx={{ height: '100%', width: '300px' }}>
                  <Paper
                    elevation={4}
                    sx={{
                      p: 4,
                      borderRadius: 4,
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      backgroundColor: '#ffffff',
                    }}
                  >
                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#003366' }}>
                      Our Address
                    </Typography>
                    <Typography variant="body1" sx={{ color: '#555' }}>
                      Fayyaz Garden, <br />
                      K.B. Road, Near PWD Colony<br />
                      RAMPUR, UTTAR PRADESH<br />
                      PIN: 244901
                    </Typography>
                  </Paper>
                </Box>
              </Grid>

              <Grid item xs={12} md={6}>
                <Box sx={{ height: '100%', width: '500px' }}>
                  <Paper
                    elevation={4}
                    sx={{
                      p: 4,
                      borderRadius: 4,
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      backgroundColor: '#ffffff',
                    }}
                  >
                    <iframe
                      title="Google Map"
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14229.223241731514!2d79.0193064!3d28.814186!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39a007b11a40d74d%3A0x84c6eeb944e3562d!2sRampur%2C%20Uttar%20Pradesh%20244901!5e0!3m2!1sen!2sin!4v1689941412693!5m2!1sen!2sin"
                      width="100%"
                      height="100%"
                      style={{ border: 0 }}
                      allowFullScreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                  </Paper>
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Box>

        <LayoutLandingFooter />
      </Box>
    </GSTLoader>
  );
};

export default ContactUS;

